import { max } from "lodash";
import { BaseEntity } from "./BaseEntity";
import { reference } from "@popperjs/core";

export class IXCCustomerEntity extends BaseEntity {
    constructor() {
        super();

        this.entityName = "components.settings.permissionManagementList.Person";
        this.pageTitle = "";
        this.menuPath = "";
        this.APIRoute = "Resources/Person"
        this.i18nBase = "";
        this.baseEndPoint = "person";
        this.endpoints = {
            list: `${this.baseEndPoint}`,
            create: `${this.baseEndPoint}`,
            get: `${this.baseEndPoint}/:id`,
            delete: `${this.baseEndPoint}/:id`,
        };

        this.fields = [
            {
                key: "identity",
                label: "common.labels.code",
                type: "text",
                visible: true,
                editable: true,
                cols: 6,
                path: "identity"
            },
            {
                key: "name",
                label:  `common.labels.name`,
                type: "text",
                visible: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "price",
                label: "common.labels.price",
                type: "text",
                visible: true,
                editable: true,
                path: "price",
                cols: 3

            },
            {
                key: "st_product_service",
                label:  "common.labels.type",
                type: "text",
                visible: true,
                cols: 3,
                path: "st_product_service"
            },
            {
                key: "category",
                label: "Categoria",
                type: "text",
                visible: true,
                cols: 3,
                path: "category"
            },
            {
                key: "max_download",
                label: "Max download",
                type: "text",
                visible: true,
                cols: 3,
                path: "max_download"
            },
            {
                key: "max_upload",
                label: "Max upload",
                type: "text",
                visible: true,
                cols: 3,
                path: "max_upload"
            }
        ]

        this.tableColumns = [
            {
                key: "id",
                label: "user.fields.id",
                type: "text",
                visible: false,
                editable: false,
                orderBy: false,
                path: "id"
            },
            {
                key: "name",
                label: "labels.common.name",
                type: "text",
                visible: true,
                required: true,
                editable: true,
                cols: 6,
                path: "name"
            },
            {
                key: "external_identity",
                label: "CPF/CNPJ",
                type: "text",
                visible: true,
                required: false,
                editable: true,
                cols: 6,
                path: "external_identity"
            },
            {
                key: "status",
                label: null,
                type: "activeSwitch",
                visible: true,
                required: true,
                editable: true,
                orderBy: false,
                cols: 12,
                path: "status"
            },
        ]

        this.nfeTable = [
            {
                key: "id_nf",
                label: "Documento",
                visible: true,
                orderBy: false,
                width: "80px"
            },
            {
                key: "data_emissao",
                label: "Data emissão",
                visible: true,
                orderBy: false,
                width: "80px"

            },
            {
                key: "tipo_documento",
                label: "Tipo de documento",
                visible: true,
                orderBy: false,
                width: "80px",
                maxChars: 20

            },
            {
                key: "modelo_nf",
                label: "Modelo NF",
                visible: true,
                orderBy: false
            },
            {
                key: "numero_nf",
                label: "Número NF",
                visible: true,
                orderBy: false,
                width: "80px"
            },
            {
                key: "valor_nf",
                label: "Valor total",
                visible: true,
                orderBy: false,
                width: "30px"

            },
        ];

        this.searchEquipment = [
            {
                key: "SerialNumberMacAddress",
                label: "components.customers.index.searchBySerialMacOrProtocol",
                placeholder:"common.labels.enterTheNumber",
                type: "text",
                visible: true,
                editable: true,
                remove:[':'],
                cols: 12,
                path: "SerialNumberMacAddress"
            }
        ];

        this.nfeItemsTable = [
            {
                key: "descricao",
                label: "Descrição",
                visible: true,
                orderBy: false,
                maxChars: 40
            },
            {
                key: "quantidade",
                label: "Quantidade",
                visible: true,
                orderBy: false
            },
            {
                key: "valor_unitario",
                label: "Valor unitário",
                visible: true,
                orderBy: false
            },
            {
                key: "valor_total_produto",
                label: "Valor total",
                visible: true,
                orderBy: false
            }
        ];

        this.comodatoTable = [
            {
                key: "descricao_produto",
                label: "Produto",
                visible: true,
                orderBy: false,
                maxChars: 25,
                width: "180px"
            },
            {
                key: "st_comodato_emp_dev_baixa",
                label: "Status",
                visible: true,
                orderBy: false,
                width: "100px"
            },
            {
                key: "data_movimentacao",
                label: "Data movimentação",
                visible: true,
                orderBy: false,
                width: "110px"
            },
            {
                key: "estrada_saida",
                label: "Origem",
                visible: true,
                orderBy: false,
                width: "130px"
            },
            {
                key: "quantidade",
                label: "Qtd",
                visible: true,
                orderBy: false,
                width: "60px"
            },
            {
                key: "valor_unitario",
                label: "Valor unitário",
                visible: true,
                orderBy: false,
                width: "100px"
            },
            {
                key: "valor_total",
                label: "Valor total",
                visible: true,
                orderBy: false,
                width: "110px"
            },
            {
                key: "mac",
                label: "MAC",
                visible: true,
                orderBy: false,
                width: "140px"
            }
        ];

        this.customActions = {
            duplicate: false
        }

        this.tableColumns = [
            {
                key: "name",
                label: "common.labels.name",
                visible: true,
                orderBy: true
            },
            {
                key: "doc_identity",
                label: "Documento",
                visible: true,
                orderBy: true
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: true
            },
            {
                key: "actions",
                label: "common.labels.actions",
                visible: true,
                orderBy: false
            },
        ]

        this.supportTable = [
            {
                key: "protocolo",
                label: "Protocolo",
                visible: true,
                orderBy: false
            },
            {
                key: "data_criacao",
                label: "Data criação",
                visible: true,
                orderBy: false
            },
            {
                key: "data_ultima_alteracao",
                label: "Última alteração",
                visible: true,
                orderBy: false
            },
            {
                key: "titulo",
                label: "Título",
                visible: true,
                orderBy: false,
                maxChars: 35,
                width: "100px",

            },
            {
                key: "atendente",
                label: "Atendente",
                visible: true,
                orderBy: false,
                width: "100px",
                maxChars: 35,
            },
            {
                key: "prioridade",
                label: "Prioridade",
                visible: true,
                orderBy: false
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: false
            }
        ];

        this.financeTable = [
            {
                key: "data_emissao",
                label: "Data emissão",
                visible: true,
                orderBy: false
            },
            {
                key: "data_vencimento",
                label: "Data vencimento",
                visible: true,
                orderBy: false
            },
            {
                key: "document",
                label: "Documento",
                visible: true,
                orderBy: false,
                link: (row) => ({
                    path: window.location.pathname,
                    query: {
                        tab: 2,
                        document: row.document
                    }
                })
            },
            {
                key: "parcela",
                label: "Parcela",
                visible: true,
                orderBy: false
            },
            {
                key: "tipo_recebimento",
                label: "Origem/Tipo",
                visible: true,
                orderBy: false
            },
            {
                key: "valor",
                label: "Valor",
                visible: true,
                orderBy: false
            },
            {
                key: "data_pagamento",
                label: "Data pagamento",
                visible: true,
                orderBy: false
            },
            {
                key: "valor_recebido",
                label: "Valor recebido",
                visible: true,
                orderBy: false
            },
            {
                key: "status",
                label: "common.labels.status",
                visible: true,
                orderBy: false
            },
        ];

        this.historyTable = [
            {
                key: "historico",
                label: "Histórico",
                smallScreenMaxChars: 60,
                visible: true,
                orderBy: false
            },
            {
                key: "data_historico",
                label: "Data",
                smallScreenMaxChars: 20,
                visible: true,
                orderBy: false
            },
            {
                key: "tipo_historico",
                label: "Tipo",
                smallScreenMaxChars: 60,
                visible: true,
                orderBy: false
            },

        ]

        this.pages = {
            view: {
                pageTitle: `Visão Cliente`,
                pathI18n: `/Clientes`,
                route: ["/ixc/customers","/ixc/customers", "/ixc/customers/view/:id"]
            },
            list: {
                pageTitle: `Clientes`,
                pathI18n: `/`,
                route: ["/", "/ixc/customers"],
                filters: {
                    quickSearch: {
                        info: "common.messages.info.searchByName",
                        searchBy: ["name"],
                        type: "text",
                    },
                    advanced: {
                        fields: [
                            {
                                key: "status",
                                label: "common.labels.status",
                                type: "select",
                                options: [
                                    { label: "common.labels.active", value: true },
                                    { label: "common.labels.inactive", value: false },
                                ],
                                path:"status"
                            },
                        ],
                    },
                },
            },
        };
    }

    getUrl(endpoint, params = {}) {
        let url = endpoint;
        Object.keys(params).forEach(key => {
            url = url.replace(`:${key}`, params[key]);
        });
        return url;
    }
}
